










import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';

export default Vue.extend({
    name: 'Btn',

    props: {
        icon: {
            type: String,
            required: false,
        },

        text: {
            type: String,
            required: false,
        },

        size: {
            type: String,
            required: false,
        },

        color: {
            type: String,
            required: false,
        },

        state: {
            type: String,
            required: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            tempText: '',
            tempState: '',
        };
    },

    methods: {
        setTempState(state: string, text: string, ms: number = 5000) {
            if (text) {
                this.tempText = text;
            }
            this.tempState = state;
            setTimeout(() => {
                this.tempText = '';
                this.tempState = '';
            }, ms);
        },

        setLoading(yea = true) {
            this.tempState = yea === true ? 'load' : '';
        },

        setSuccess(text: string, ms: number) {
            this.setTempState('success', text, ms);
        },

        setError(text: string, ms: number) {
            this.setTempState('error', text, ms);
        },
    },

    computed: {
        getText() {
            return this.tempText || this.text;
        },

        getState() {
            return this.tempState || this.state;
        },
    },
});
